import { render, staticRenderFns } from "./BtnDownloadLeads.vue?vue&type=template&id=7736c3b2&v-slot%3Aextension=true&"
import script from "./BtnDownloadLeads.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports